/* eslint-disable react/destructuring-assignment */
import tippy from "tippy.js";
import { datepicker, localeNl } from "@mobiscroll/javascript";

// CUSTOM MODULES
import Styleguide from "./modules/Styleguide";
import Layoutgrid from "./modules/Layoutgrid";

import RenderView from "./modules/RenderView";
import Accordion from "./modules/Accordion";
import ShowCookies from "./modules/nb-cookiepopup";

import Cookies from "js-cookie";

/**
 *  App object
 *
 *  The app object functions a the main back-bone of the javascript used in this
 *  project and will be bound to window.
 *
 */

const app = {
  onDocumentReady: (fn) => {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
      document.addEventListener("DOMContentLoaded", app.handleModal);
    }
  },
  handleRenderView: (element) => new RenderView(element),
  handleStyleguide: () => new Styleguide(),
  handleLayoutgrid: () => new Layoutgrid(),
  showCookies: () => new ShowCookies(),
  handleModal() {
    const body = document.getElementsByTagName("body")[0];
    const headerEl = document.querySelector("header.header");
    const triggers = document.querySelectorAll(".js--open-modal");
    const form = document.querySelector(".js-prefill-form");

    function openModal(id) {
      const modal = document.querySelector(`#${id}`);


      if (modal && !modal.dataset.hasOwnProperty('preventOpen')) {
        /** add active class to modal */
        modal.classList.add("modal--active");

        /** add overlay to root */
        body.classList.add("is-modal-open");

        /** add modal--center to root if modal should be displayed in the center */
        if (modal.classList.contains("modal--center")) {
          body.classList.add("is-modal-open--center");
        }
      }
    }

    function closeModal() {
      /** find the active modal */
      const parent = document.querySelector(".modal--active");

      /** remove active state from modal */
      if (parent) {
        parent.classList.remove("modal--active");
      }

      /** remove the overlay from the root */
      body.classList.remove("is-modal-open", "is-modal-open--center");
    }

    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const fields = form.querySelectorAll("input");
        const values = [...fields].map((field) => {
          let value = field.value;

          if (field.type === "checkbox") {
            value = field.checked;
          }

          return { [field.name]: value };
        });

        if (values) {
          Cookies.set("prefilledForm", JSON.stringify(values), { expires: 40 });

          const parent = document.querySelector(".modal--active");
          if (parent) parent.classList.remove("modal--active");
          body.classList.remove("is-modal-open", "is-modal-open--center");

          Cookies.set("howDoesItWorkPopup", 1, { expires: 40 });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            interactie_naam: "Kies je keukenstijl",
            interactie_stap: "1",
            interactie_stap_conversie: "false",
            event: "Keuken Configureren",
          });

          closeModal();
        }
      });
    }

    if (triggers.length) {
      body.classList.add("has-modal");
    }

    document.querySelectorAll(".modal").forEach((modal) => {
      if (!modal.classList.contains("modal--center")) {
        // eslint-disable-next-line no-param-reassign
        modal.style.top = `${headerEl.offsetHeight}px`;
        // eslint-disable-next-line no-param-reassign
        modal.style.height = `calc(100vh - ${headerEl.offsetHeight}px)`;
      }
    });

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        /** if trigger has dataset, open modal with the id as specified in modelTarget  */
        if (trigger.dataset) {
          const targetId = trigger.dataset.modalTarget;
          openModal(targetId);
        }
      });
    });

    const closeTriggers = document.querySelectorAll(
      ".modal__close-button, .js--modal-close"
    );
    closeTriggers.forEach((close) => {
      close.addEventListener("click", () => {
        /** close all modals */
        closeModal();
      });
    });

    const editMode = document.body.dataset.editMode;

    /** open entry popup if the user has accepted the cookie popup, and has no prefilled information.
     * But only do this if it's not edit mode */
    const rootEl = document.querySelector('body');

    if (rootEl) {
      const isKiosk = rootEl.dataset?.kiosk === '1';

      if (editMode === "false") {
        if (Cookies.get("gtmCookiePopup") && !Cookies.get("prefilledForm") && !isKiosk) {
          openModal("entry-popup");
        }
      }
    }
  },
  handleLogin(e) {
    e.preventDefault();
    const toaster = document.getElementById("loginToaster");
    toaster.classList.add("alert", "alert-danger");
    const email = e.target.email.value;
    const password = e.target.password.value;

    if (!email || !password) {
      toaster.classList.remove("visuallyhidden");
      toaster.innerText = "Voer e-mail en wachtwoord in";
      return false;
    }

    const formData = new FormData();
    formData.append("_username", email);
    formData.append("_password", password);
    formData.append("_remember_me", e.target.remember_me.value);

    fetch("/account/login?isAjax=1", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if ("idEncoded" in data) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            user_id: data.idEncoded,
            event: "Account Login",
          });
        }
        if ("error" in data) {
          toaster.classList.remove("visuallyhidden");
          toaster.innerText = data.error;
        } else if ("user" in data && "idEncoded" in data) {
          window.location.replace("/mijn-omgeving");
        } else {
          toaster.classList.remove("visuallyhidden");
          toaster.innerText =
            data.message || "Er is iets mis gegaan tijdns het inloggen";
        }
      })
      .catch(console.error);

    return null;
  },
  handlePasswordForgotten(e) {
    e.preventDefault();
    const formEl = e.target;
    const email = formEl.email.value;
    const toaster = document.getElementById("passwordResetToaster");

    if (!email) {
      toaster.classList.add("alert", "alert-danger");
      toaster.classList.remove("visuallyhidden");
      toaster.innerText = "Voer je e-mailadres in";
      return false;
    }

    const data = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax
    for (const pair of new FormData(formEl)) {
      data.append(pair[0], pair[1]);
    }

    fetch("/account/api/verstuur-wachtwoord-reset", {
      method: "POST",
      body: data,
    })
      .then(() => {
        toaster.classList.add("alert", "alert-success");
        toaster.classList.remove("visuallyhidden");
        toaster.innerText = "Wachtwoordreset is verzonden";
      })
      .catch(console.error);

    return null;
  },
  submitNameInput(id, hash) {
    const input = document.querySelector(`[js-name-edit-input='${id}']`);

    if (!input || !id || !hash) return;

    const data = new URLSearchParams();
    data.append("hash", hash);
    data.append("configurationName", input.value);

    fetch("/mijn-omgeving/gegevens/configuratie/update", {
      method: "POST",
      body: data,
    })
      .then(() => {
        const holder = document.querySelector(`[js-name-holder='${id}']`);
        holder.textContent = input.value;
        app.toggleNameInput(id);
      })
      .catch(console.error);
  },
  toggleNameInput(id) {
    const container = document.querySelector(`[js-name-container='${id}']`);
    const editContainer = document.querySelector(
      `[js-name-edit-container='${id}']`
    );
    container.classList.toggle("hidden");
    editContainer.classList.toggle("hidden");
  },
  displayLoginForm() {
    document.getElementById("loginform").style.display = null;
    document.getElementById("passwordresetform").style.display = "none";
  },
  displayPasswordResetForm() {
    document.getElementById("loginform").style.display = "none";
    document.getElementById("passwordresetform").style.display = null;
  },
};

function init() {
  // Init code here
  tippy(".js-tippy");

  const accordionMenus = document.querySelectorAll(".js-accordion");
  for (let i = 0; i < accordionMenus.length; i++) {
    const element = accordionMenus[i];
    // eslint-disable-next-line no-new
    new Accordion(element);
  }
}

app.onDocumentReady(init);

window.app = app;
window.mobiscroll = {
  datepicker,
  localeNl,
};

// eslint-disable-next-line no-extend-native
Date.prototype.addWorkDays = function (days) {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(days)) {
    console.log('Value provided for "days" was not a number');
    return;
  }

  // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
  const dow = this.getDay();
  // eslint-disable-next-line radix
  let daysToAdd = parseInt(days);
  // If the current day is Sunday add one day
  if (dow === 0) {
    // eslint-disable-next-line no-plusplus
    daysToAdd++;
  }
  // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
  if (dow + daysToAdd >= 6) {
    // Subtract days in current working week from work days
    const remainingWorkDays = daysToAdd - (5 - dow);
    // Add current working week's weekend
    daysToAdd += 2;
    if (remainingWorkDays > 5) {
      // Add two days for each working week by calculating how many weeks are included
      daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
      // Exclude final weekend if the remainingWorkDays resolves to an exact number of weeks
      if (remainingWorkDays % 5 === 0) {
        daysToAdd -= 2;
      }
    }
  }
  this.setDate(this.getDate() + daysToAdd);
};
